<template>
  <div>
    <h4>Markets</h4>

    <b-table :items="markets" :fields="fields" bordered small responsive>
      <!-- Description -->
      <template #cell(description)="data">
        <div v-if="data.item.isNew">
          <b-form-input v-model="data.item.description" size="sm" required />
        </div>
        <div v-else>
          <strong>{{ data.item.description }}</strong>
        </div>
      </template>

      <!-- Status -->
      <template #cell(enabled)="data">
        <b-badge :variant="badgeColor(data.item.enabled)">
          {{ data.item.enabled ? "Enable" : "Disable" }}
        </b-badge>
      </template>

      <!-- Can Multi -->
      <template #cell(canMulti)="{ item }">
        <div v-if="checkCanMulti(item)" class="d-flex justify-content-center">
          <b-form-checkbox v-model="item.canMulti" switch @click.native.prevent="showModal('can-multi', item)" />
        </div>
      </template>

      <!-- Actions -->
      <template #cell(actions)="{ item }">
        <div class="">
          <b-button v-if="item.enabled" variant="danger" size="sm" @click="showModal('change-status', item)">
            Disable
          </b-button>
          <b-button v-else variant="primary" size="sm" @click="showModal('change-status', item)">
            Enable
          </b-button>
        </div>
      </template>
    </b-table>

    <!-- Pagination -->
    <div class="d-flex flex-column flex-wrap align-items-center justify-content-center mt-1">
      <span>Showing 1-{{ markets.length }} of {{ markets.length }} markets</span>
      <b-pagination v-model="page" :total-rows="markets.length" :per-page="markets.length" first-number last-number
        class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
        <template #first-text><span class="text-success">First</span></template>
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
        <template #last-text><span class="text-info">Last</span></template>
      </b-pagination>
    </div>

    <!-- MODAL CONFIRM -->
    <b-modal ref="modal" :title="modal.title" centered cancel-variant="outline-secondary" :ok-disabled="isSubmitting"
      @ok="handleSubmitModal">
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BRow,
  BCol,
  BTable,
  BFormSelect,
  BBadge,
  BPagination,
  BCardText,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapState, mapActions } from "vuex";
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BRow,
    BCol,
    flatPickr,
    BTable,
    BFormSelect,
    BBadge,
    BPagination,
    BCardText,
    Spinner,
  },

  data() {
    return {
      configDate: {
        enableTime: true,
        altFormat: "d-m-Y H:i:S",
        dateFormat: "Y-m-d H:i:S",
        enableSeconds: true,
        static: true,
      },
      fields: [
        { key: "description", label: "Description" },
        { key: "enabled", label: "Status" },
        { key: "canMulti", label: "Can Multi", class: "text-center" },
        { key: "actions", label: "Actions" },
      ],

      markets: [],
      page: 1,
      action: {
        type: "",
        item: "",
      },
      modal: {
        title: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapState("trading/racing", ["dataRaceDetail", "loadingUpdateConfig"]),
    isSubmitting() {
      return this.loadingUpdateConfig;
    },
  },
  created() {
    this.convertDataConfigMarket();
  },
  watch: {
    dataRaceDetail(val) {
      this.convertDataConfigMarket();
    },
  },
  methods: {
    ...mapActions("trading/racing", [
      "updateRaceConfigMarket",
      "getDetailOfRace",
    ]),
    convertDataConfigMarket() {
      const data = this.dataRaceDetail?.betTypeConfig?.rules;
      if (!data) return;
      const arrayData = Object.entries(data).map(([key, value]) => ({
        type: key,
        description: this.convertMarketName(key) ? this.convertMarketName(key) : key,
        ...value,
      }));
      console.log('arrayData', arrayData.map(i => ({ type: i.type, description: i.description, enabled: i.enabled, canMulti: i.canMulti })));
      this.markets = arrayData;
    },
    convertMarketName(name) {
      switch (name) {
        case "win":
          return "WIN";
        case "place":
          return "PLACE";
        case "quinella":
          return "QUINELLA";
        case "exacta":
          return "EXACTA";
        case "trifecta":
          return "TRIFECTA";
        case "first4":
          return "FIRST FOUR";
        case "earlyQuaddie":
          return "EARLY QUADDIE";
        case "lateQuaddie":
          return "QUADDIE";
        case "srm":
          return "SAME RACE MULTI";
        case "eachWayFixed":
          return "EACH WAY FIXED";
        case "bestDivSp":
          return "BEST DIV SP";
        case "midDivPlace":
          return "MID DIV PLACE";
        case "midDivWin":
          return "MID DIV WIN";
        case "eachWayMidDivMidDivPlace":
          return "EACH WAY MID MID";
        case "eachWayBestDivMidPlace":
          return "EACH WAY BT+ MID";
        case "topK":
          return "MORE PLACES";
        case "sp":
          return "SP";
        case "dailyDouble":
          return "DAILY DOUBLE";
        case "runningDouble":
          return "RUNNING DOUBLE";
        case "treble":
          return "TREBLE";
        case "srm":
          return "SAME RACE MULTI";
        case "comboRacing":
          return "COMBO RACING";
        default:
          break;
      }
    },

    badgeColor(status) {
      switch (status) {
        case true:
          return "success";
        case false:
          return "secondary";
        default:
          return "secondary";
      }
    },
    checkCanMulti(item) {
      const list = [
        "win",
        "place",
        "eachWayFixed",
        "bestDivSp",
        "midDivPlace",
        "midDivWin",
        "eachWayMidDivMidDivPlace",
        "eachWayBestDivMidPlace",
        "topK",
        "sp",
      ];
      return list.some((i) => item.type === i);
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "change-status") {
        this.setModal(
          item.enabled ? "Disable Market" : "Enable Market",
          `Are you sure you want to ${item.enabled ? "disable" : "enable"
          }  market ${item.description}?`,
        );
      }

      if (type === "can-multi") {
        this.setModal(
          item.canMulti ? "Disable Multi" : "Enable Multi",
          `Are you sure you want to ${item.canMulti ? "disable" : "enable"
          } bet multi of market ${item.description}?`,
        );
      }

      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "change-status") await this.handleChangeStatus(item);
      if (type === "can-multi") await this.handleChangeBetMulti(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleChangeStatus(i) {
      const data = this.markets.reduce((acc, item) => {
        const newData =
          i.type === item.type
            ? {
              ...i,
              enabled: !i.enabled,
              adminLock: true,
            }
            : item;
        const { type, ...rest } = newData;
        acc[this.convertType(type)] = rest;
        return acc;
      }, {});
      const result = await this.updateRaceConfigMarket({
        raceId: this.$route.query.raceId,
        betTypeConfig: {
          rules: data,
        },
      });
      if (result) {
        this.showToastSuccess("Success", "Updated status successfully!");
        this.getDetailOfRace(this.$route.query.raceId);
      }
    },
    async handleChangeBetMulti(i) {
      const data = this.markets.reduce((acc, item) => {
        const newData =
          i.type === item.type
            ? {
              ...i,
              canMulti: !i.canMulti,
              adminLock: true,
            }
            : item;
        const { type, ...rest } = newData;
        acc[this.convertType(type)] = rest;
        return acc;
      }, {});
      const result = await this.updateRaceConfigMarket({
        raceId: this.$route.query.raceId,
        betTypeConfig: {
          rules: data,
        },
      });
      if (result) {
        this.showToastSuccess("Success", "Updated bet multi successfully!");
        this.getDetailOfRace(this.$route.query.raceId);
      }
    },
    convertType(type) {
      switch (type) {
        case "dailyDouble":
          return "daily-double";
        case "runningDouble":
          return "running-double";
        case "comboRacing":
          return "combo-racing";
        case "eachWayFixed":
          return "each-way-fixed";
        case "bestDivSp":
          return "best-div-sp";
        case "midDivPlace":
          return "mid-div-place";
        case "midDivWin":
          return "mid-div-win";
        case "eachWayMidDivMidDivPlace":
          return "each-way-mid-div-mid-div-place";
        case "eachWayBestDivMidPlace":
          return "each-way-best-div-mid-place";
        case "topK":
          return "top-k";
      }
      return type;
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>
